import { useEffect, useImperativeHandle, useRef, useState } from "react";

export type PopoverRef = {
  open: () => void;
  close: () => void;
};

export function Popover({
  children,
  handler,
  offset = { x: 0, y: 20 },
  ref,
}: {
  children: React.ReactNode;
  handler: React.ReactNode;
  offset?: { x: number; y: number };
  ref?: React.RefObject<PopoverRef | null>;
}) {
  const [open, setOpen] = useState(false);
  const divRef = useRef<HTMLDivElement>(null);

  useImperativeHandle(ref, () => ({
    open: () => setOpen(true),
    close: () => setOpen(false),
  }));

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (divRef.current && !divRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <div ref={divRef} className="relative">
      <button className="cursor-pointer" onClick={handleClick}>
        {handler}
      </button>
      {open && (
        <div
          className="absolute z-100"
          style={{ top: offset.y, right: offset.x }}
        >
          {children}
        </div>
      )}
    </div>
  );
}
